import { Box, Button, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { MatchingPropertieShow } from './matching-properties/MatchingPropertieShow';
import { ProjectAddElementButton } from './project/ProjectAddElementButton';
import { NewMatchingProperty } from '../new/NewMatchingProperty';
import ExoDialog from './ExoDialog';
import { updateOrCreate } from '../special/updateOrCreate';
import useFetch from '../../api/useFetch';
import { MatchingPropertiesList } from './matching-properties/MatchingPropertiesList';
import { tokens } from '../../global/theme/tokens';
import { useTranslation } from 'react-i18next';
import { API_PATCH, DBRequest, useConfig } from '../../api/api';
import Loader from '../special/Loader';
import Feedback from '../special/Feedback';

export const ExoMatchingProp = ({
  properties,
  isEditMode,
  isLead,
  salesLevelId,
  salesObjectId,
  onChange,
  onFeedback,
  noValueEdit,
  className = ' px-2 flex flex-col',
  onSalesObjectChange,
  noGlobalList,
  objectProperties,
  assingMode,
  onSelectionChange,
  addLabel,
  allowAdding = true,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const config = useConfig();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  function handlePropChange(newProp) {
    const newProps = updateOrCreate(objectProperties, newProp.data);
    onChange(newProps, newProp, salesLevelId);
  }

  function saveProps() {
    DBRequest({
      config,
      path: `sales-objects/${salesObjectId}/relations`,
      method: API_PATCH({ properties }),
      onResponse: onSalesObjectChange,
      onLoading: setIsLoading,
      onFeedback: handleFeedback,
    });
  }

  // feedback
  const [alertState, setAlertState] = useState({
    alertOpen: false,
    alertType: 'info',
    alertText: 'test',
  });
  function handleFeedback(text, type) {
    setAlertState({ alertOpen: true, alertText: text, alertType: type });
  }

  return (
    <Box className="flex flex-col gap-4">
      <Loader active={isLoading} />
      <Box className={className}>
        {properties.map((property) => (
          <MatchingPropertieShow
            isLead={isLead}
            key={property.id}
            property={property}
            isEditMode={isEditMode && !noValueEdit}
            onChange={handlePropChange}
          />
        ))}

        <ExoDialog open={open} onClose={() => setOpen(false)} limitWidth>
          <MatchingPropertiesList
            objectProperties={objectProperties}
            properties={properties}
            salesLevelId={salesLevelId}
            salesObjectId={salesObjectId}
            onPropChange={handlePropChange}
            isEditMode={isEditMode}
            noGlobalList={noGlobalList}
            onClose={() => setOpen(false)}
            noValueEdit={noValueEdit}
            onSelectionChange={onSelectionChange}
          />
        </ExoDialog>
      </Box>
      {isEditMode && allowAdding && (
        <ProjectAddElementButton
          addLabel={addLabel}
          sizePx="30px"
          onClick={() => setOpen(true)}
        />
      )}
      {isEditMode && !noValueEdit && (
        <Box className="flex flex-row-reverse">
          <Button
            variant="contained"
            sx={{ bgcolor: colors.success }}
            onClick={saveProps}
          >
            {t('Save')}
          </Button>
        </Box>
      )}
      <Feedback setState={setAlertState} state={alertState} />
    </Box>
  );
};
